import { useCallback, useMemo } from 'react';
import { generatePath } from 'react-router-dom';

import { FinanceProvider } from '@kanda-libs/ks-frontend-services';

import { URLS } from 'config';
import { scrollToTop } from 'utils';

import { LIST } from './constants';
import { formatTradingName } from './helpers';

import { useApplyContext } from '../context';

export interface ApplyWelcomeHook {
  provider: FinanceProvider | undefined;
  tradingName: string;
  isLoading: boolean;
  isExampleJob: boolean;
  isIntroduced: boolean;
  list: string[];
  onClick: () => void;
}

export default function useApplyWelcome(): ApplyWelcomeHook {
  const {
    job,
    jobCompanyInfo,
    id,
    introduction,
    provider,
    isLoading,
    isIntroduced,
    goToPage,
  } = useApplyContext();
  const tradingName = useMemo(
    () => formatTradingName(job, jobCompanyInfo, introduction),
    [job, jobCompanyInfo, introduction],
  );

  const isExampleJob = job?.flow_type === 'example';

  const list = useMemo(() => {
    if (job?.introduced_to) return LIST.introduction.list.items;
    if (provider === 'etika' && !isExampleJob) return LIST.etika.list.items;
    return LIST.default.list.items;
  }, [job, provider, isExampleJob]);

  const onClick = useCallback(() => {
    if (!id || isLoading) return;
    goToPage('TERMS_AND_CONDITIONS');
    const url = new URL(window.location.href);
    const nextUrl = `${url.origin}${generatePath(
      URLS.applyForFinanceTermsAndConditions,
      {
        id,
      },
    )}`;
    window.history.pushState(window.history.state, '', nextUrl);
    setTimeout(() => scrollToTop(), 10);
  }, [id, goToPage, isLoading]);

  return {
    provider,
    tradingName,
    isLoading,
    isExampleJob,
    isIntroduced,
    list,
    onClick,
  };
}
